import React from 'react';

function SpaceManager({ size }) {
  return <div style={{ height: size || '1rem' }} />;
}

export default SpaceManager;
